import React from 'react';
import PropTypes from 'prop-types';
import { themr } from 'react-css-themr';

import styles from './ProgressBar.scss';

const getPercentage = (total, completion) => {
  let percentage = 0;
  if (completion <= total) {
    percentage =
      completion > 0 ? Number((completion / total) * 100).toFixed(2) : 0;
  } else {
    percentage = 100;
  }

  return percentage;
};

const ProgressBar = ({ total, completion, theme }) => {
  const percentage = getPercentage(total, completion);

  return (
    <div className={theme.root}>
      <span
        style={{
          width: `${percentage}%`,
        }}
      />
    </div>
  );
};

ProgressBar.propTypes = {
  theme: PropTypes.object.isRequired,
  completion: PropTypes.number,
  total: PropTypes.number,
};

ProgressBar.defaultProps = {
  completion: 0,
  total: 0,
};

export default themr('ProgressBar', styles)(ProgressBar);



// WEBPACK FOOTER //
// ./app/components/ProgressBar/ProgressBar.jsx